import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SkillResolutionService } from '../SkillResolutionService';

// Each hook invalidates the queue list (every filter/page combo) and the
// detail query for the specific norm just acted on, so the next time either
// is fetched it reflects the real server state. The record modal itself
// doesn't wait on that refetch — it applies a local status patch immediately
// (see SkillResolution.jsx) and this invalidation just keeps everything else
// (other pages, other filters, a revisit) honest.
const invalidateNorm = (queryClient, nameNorm) => {
  queryClient.invalidateQueries({ queryKey: ['skill-resolution', 'queue'] });
  queryClient.invalidateQueries({
    queryKey: ['skill-resolution', 'queue-detail', nameNorm],
  });
};

export const useResolveNewSkill = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body) => SkillResolutionService.resolveNewSkill(body),
    onSuccess: (_, body) => invalidateNorm(queryClient, body.name_norm),
  });
};

export const useResolveAlias = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body) => SkillResolutionService.resolveAlias(body),
    onSuccess: (_, body) => invalidateNorm(queryClient, body.name_norm),
  });
};

export const useResolveMap = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body) => SkillResolutionService.resolveMap(body),
    onSuccess: (_, body) => invalidateNorm(queryClient, body.name_norm),
  });
};

export const useResolveBlock = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body) => SkillResolutionService.resolveBlock(body),
    onSuccess: (_, body) => invalidateNorm(queryClient, body.name_norm),
  });
};
